import { render, staticRenderFns } from "./qr.vue?vue&type=template&id=8c74d6ca&scoped=true"
import script from "./qr.vue?vue&type=script&lang=js"
export * from "./qr.vue?vue&type=script&lang=js"
import style0 from "./qr.vue?vue&type=style&index=0&id=8c74d6ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c74d6ca",
  null
  
)

export default component.exports